import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

type Theme = "light" | "dark";

interface TaggingThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const TaggingThemeContext = createContext<TaggingThemeContextType | undefined>(
  undefined,
);

export function TaggingThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem("tagging-v2-theme") as Theme) || "light",
  );

  useEffect(() => {
    localStorage.setItem("tagging-v2-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "light" ? "dark" : "light"));
  };

  return (
    <TaggingThemeContext.Provider
      value={{
        theme,
        toggleTheme,
      }}
    >
      {children}
    </TaggingThemeContext.Provider>
  );
}

export function useTaggingTheme() {
  const context = useContext(TaggingThemeContext);
  if (!context) {
    throw new Error("useTaggingTheme must be used within TaggingThemeProvider");
  }
  return context;
}
